/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { exportTargetMappingUpdate } from '../../axios/exportTargetMappingUpdate'
import type {
	ExportTargetMappingUpdateError,
	ExportTargetMappingUpdatePathParams,
	ExportTargetMappingUpdateRequest,
	ExportTargetMappingUpdateResponse,
} from '../../types/ExportTargetMappingUpdate'

export const exportTargetMappingUpdateMutationKey = () => [{ url: '/export-target-mappings/:mapping' }] as const

export type ExportTargetMappingUpdateMutationKey = ReturnType<typeof exportTargetMappingUpdateMutationKey>

export type ExportTargetMappingUpdateVariables = {
	mapping: ExportTargetMappingUpdatePathParams['mapping']
	data: ExportTargetMappingUpdateRequest
}

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportTargetMappingController.php ExportTargetMappingController::update */
export function useExportTargetMappingUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		ExportTargetMappingUpdateResponse,
		AxiosError<ExportTargetMappingUpdateError>,
		ExportTargetMappingUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: exportTargetMappingUpdateMutationKey(),
		mutationFn: ({ mapping, data }: ExportTargetMappingUpdateVariables) =>
			exportTargetMappingUpdate(mapping, data, config).then(res => res.data),
		...options,
	})
}
